import React, { useState } from 'react';
import { Box, Typography, Button, Container, Grid, Paper } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import PublicHeader from '../components/PublicHeader';
import FloatingConsultButton from '../components/FloatingConsultButton';
import RegisterConsultDialog from '../components/RegisterConsultDialog';
import bgImage from '../assets/images/login-bg.jpg';

const GRADIENT = 'linear-gradient(45deg, #1a237e 30%, #3949ab 90%)';

const FEATURES = [
  { title: 'مدیریت مشتریان', desc: 'ثبت و پیگیری اطلاعات مشتریان فروشگاه به‌صورت یکپارچه.' },
  { title: 'سفارش و اندازه‌گیری', desc: 'ثبت سفارش، اندازه‌گیری و پیگیری مراحل دوخت و نصب.' },
  { title: 'فاکتور و گزارش', desc: 'صدور فاکتور و گزارش فروش به‌صورت لحظه‌ای.' },
];

const LandingPage = () => {
  const [consultOpen, setConsultOpen] = useState(false);
  const navigate = useNavigate();
  const openConsult = () => setConsultOpen(true);

  return (
    <Box sx={{ minHeight: '100vh', bgcolor: '#f5f5f5' }}>
      <PublicHeader onOpenConsult={openConsult} />

      {/* Hero */}
      <Box sx={{
        position: 'relative',
        minHeight: { xs: '70vh', md: '80vh' },
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        backgroundImage: `url(${bgImage})`,
        backgroundSize: 'cover', backgroundPosition: 'center',
        textAlign: 'center', px: 2,
      }}>
        <Box sx={{ position: 'absolute', inset: 0, bgcolor: 'rgba(13, 22, 66, 0.6)' }} />
        <Box sx={{ position: 'relative', color: 'white', maxWidth: 700 }}>
          <Typography variant="h3" sx={{ fontWeight: 'bold', mb: 2, fontSize: { xs: '2rem', md: '3rem' } }}>
            سامانه مدیریت گالری پرده
          </Typography>
          <Typography variant="h6" sx={{ mb: 4, opacity: 0.9, fontWeight: 'normal' }}>
          مدیریت مشتریان، سفارش‌ها و فاکتورهای گالری پردهٔ شما، ساده یکپارچه تحت وب
          </Typography>
          <Typography variant="h8" sx={{ mb: 4, opacity: 0.7, fontWeight: 'normal' }}>
          بدون نیاز به نصب برنامه ،فقط با یک کلیک ثبت نام کنید
          </Typography>
          <Box sx={{ display: 'flex', gap: 2, justifyContent: 'center', flexWrap: 'wrap' }}>
            <Button variant="contained" size="large" onClick={openConsult}
              sx={{ bgcolor: '#ffd54f', color: '#1a237e', fontWeight: 'bold', px: 4, '&:hover': { bgcolor: '#ffca28' } }}>
              ثبت‌نام و مشاورهٔ رایگان
            </Button>
            <Button variant="outlined" size="large" onClick={() => navigate('/login')}
              sx={{ color: 'white', borderColor: 'white', px: 4, '&:hover': { borderColor: 'white', bgcolor: 'rgba(255,255,255,0.1)' } }}>
              ورود به سیستم
            </Button>
          </Box>
        </Box>
      </Box>

      {/* نمای برنامه (خلاصه) */}
      <Container id="preview" maxWidth="lg" sx={{ py: { xs: 5, md: 8 } }}>
        <Typography variant="h4" sx={{ textAlign: 'center', fontWeight: 'bold', mb: 1 }}>
          نمای برنامه مدیریت گالری پرده
        </Typography>
        <Typography sx={{ textAlign: 'center', color: 'text.secondary', mb: 5 }}>
          سامانه ثبت سفارش و مدیریت تحت وب
        </Typography>

        {/* سه کارت معرفی */}
        <Grid container spacing={3}>
          {FEATURES.map((f) => (
            <Grid item xs={12} md={4} key={f.title}>
              <Paper elevation={2} sx={{ p: 3, height: '100%', borderRadius: 3, textAlign: 'center' }}>
                <Box sx={{ width: 56, height: 56, borderRadius: '50%', background: GRADIENT, mx: 'auto', mb: 2 }} />
                <Typography variant="h6" sx={{ fontWeight: 'bold', mb: 1 }}>{f.title}</Typography>
                <Typography color="text.secondary">{f.desc}</Typography>
              </Paper>
            </Grid>
          ))}
        </Grid>

        {/* دکمهٔ مشاهدهٔ نمای کامل برنامه */}
        <Box sx={{ textAlign: 'center', mt: 5 }}>
          <Button variant="contained" size="large" onClick={() => navigate('/preview')}
            sx={{ background: GRADIENT, fontWeight: 'bold', px: 4, '&:hover': { background: 'linear-gradient(45deg, #0d1642 30%, #1a237e 90%)' } }}>
            مشاهدهٔ کامل نمای برنامه
          </Button>
        </Box>
      </Container>

      {/* فوتر */}
      <Box sx={{ background: GRADIENT, color: 'white', py: 3, textAlign: 'center' }}>
        <Typography variant="body2">© محمد نشیبی - ۱۴۰۴</Typography>
      </Box>

      <FloatingConsultButton onClick={openConsult} />
      <RegisterConsultDialog open={consultOpen} onClose={() => setConsultOpen(false)} />
    </Box>
  );
};

export default LandingPage;
